{
  window.addEventListener('DOMContentLoaded', function() {
    //action="/search" のformに input[type="hidden" name="filter.p.vendor"]を追加
    const form = document.querySelector('form[action="/search"]');
    const attributeValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('attribute='))
        ?.split('=')[1] || '';
    if (form && attributeValue) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'filter.p.vendor';
      hiddenInput.value = attributeValue;
      form.appendChild(hiddenInput);
    }


    // URLに/searchが含まれており、filter.p.vendorがない場合、filter.p.vendorを追加
    const url = new URL(window.location.href);
    if (url.pathname.includes('/search') && !url.searchParams.has('filter.p.vendor')) {
      if (attributeValue) {
        url.searchParams.set('filter.p.vendor', attributeValue);
        window.history.replaceState({}, '', url.toString());
        window.location.reload();
      }
    }

  });
}
